module.exports = __webpack_public_path__ + "img/api-economy-hero-1.2b5109fd.svg";